exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-48d9a87b]{margin-bottom:20px;display:block;background:#ebebeb}.item img[data-v-48d9a87b]{display:block;width:300px;height:168px;border-radius:4px}", ""]);

// exports
